<template>
  <div class="page_title">
    <div class="align py-3 px-4">
      <h1 class="px-1">
        <i class="fa-regular fa-newspaper icon"></i>
        Notícias para compartilhar
      </h1>
    </div>
  </div>

  <div class="align p-4 space_title">
      <PrimaryButton id="filter_button" @click="filterControl">
        <i class="fa-regular fa-filter"></i>
      </PrimaryButton>

    <div v-if="showFilter" id="filter_mask" @click="filterControl"></div>
      
    <div id="filter" :class="{ 'opened': showFilter, 'card': true, 'p-4': true,  'mb-3': true }">
          <div class="row">
            <div class="col-sm-12 mb-2 filter_item">
              <InputText placeholder="Buscar" v-model="filter.search" />
            </div>
            <div class="col-sm-3 mb-2 filter_item">
              <SelectBox
                id="site"
                placeholder="Todos os sites"
                :items="sites"
                v-model="filter.site"
                @change="changeFilter('site', filter.site)"
              >
            </SelectBox>

            </div>

            <div class="col-sm-3 mb-2 mb-md-0 filter_item">
              <SelectBox
                id="category"
                placeholder="Categoria"
                :items="categories"
                v-model="filter.category"
                @change="changeFilter('category', filter.category)"
              >
            </SelectBox>
            </div>

            <div class="col-sm-3 mb-2 mb-md-0 filter_item">
              <SelectBox
                id="order_by"
                placeholder="Mais recentes"
                :items="ordenationsOptions"
                v-model="filter.order_by"
                @change="changeFilter('order_by', filter.order_by)"
              />
            </div>

            <div class="col-sm-3 filter_item">
              <SelectBox
                id="sharing"
                placeholder="Compartilhamento"
                :items="sharingOptions"
                v-model="filter.sharing"
                @change="changeFilter('sharing', filter.sharing)"
              />
            </div>
          </div>
    </div>

    <h6 v-if="!loading && allArticles.data && !allArticles.data.length" class="no_results text-center card p-4 mt-4">
        Nenhum resultado encontrado
    </h6>

    <PreLoaderArticles v-if="loading" />

    <div v-if="!loading" class="row mt-2" id="articles_share">

      <div v-for="(article, key) in allArticles.data" :key="key" class="col-12 col-sm-6 col-lg-4 col-xl-3 mb-4">
        <div class="card h-100" :data-article-id="article.id">
          <div class="label">
            <div class="label_article">
              <span>{{ article.site_name }}</span>
              <span>{{ article.author_name }}</span>
            </div>

          </div>

          <div class="report_article" @click="openReportModal(article.id, article.title)">
            <span>Reportar</span> <i class="fa-solid fa-circle-exclamation me-1"></i>
          </div>

          <img :src="article.cover_image" height="185" class="image" />

          <div v-if="article.cpm" class="cpm_badge">
            <i class="fa-solid fa-coins me-1"></i>
            CPM {{ $moneyFormat(article.cpm) }}
          </div>

          <div class="p-4 h-100 d-flex flex-column justify-content-between">
            <h6 data-bs-toggle="tooltip" data-bs-placement="top" data-bs-animation="true" data-bs-html="true" v-tooltip title="Copiar título" class="title" @click="copyTitle(article.title)">
              {{ article.title }}
            </h6>

            <div class="d-flex flex-column mt-2">
              <div class="d-block">
                <small class="mt-1 me-3 text-nowrap">
                    <i class="fa-regular fa-calendar me-1"></i>
                    {{ $dateFormat(article.published_at) }}
                </small>

                <small class="mt-1 text-nowrap">
                  <i class="fa-regular fa-tag"></i>
                  {{ article.category_name }}
                </small>
              </div>


              <div class="d-flex mt-3">
                <PrimaryButton v-if="article.shared_at" class="w-100 me-2 green" @click="showUrlGenerator(key, article)">
                  Compartilhada
                  <small class="shared_at">{{ $dateFormat(article.shared_at) }}</small>
                </PrimaryButton>
                <PrimaryButton v-else class="w-100 me-2" @click="showUrlGenerator(key, article)">
                  Compartilhar
                </PrimaryButton>
                <a :href="article.url" target="_blank">
                  <PrimaryButton><i class="fa-solid fa-arrow-up-right-from-square"></i></PrimaryButton>
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <ListPagination :links="allArticles.meta.links" />
  </div>

  <ShareModal
    v-model="showSelectPageModal"
    :article="articleToShare"
    @shared="onShared"
    @pageShared="onPageShared"
  />

  <ModalDialog title="Reportar notícia" v-model="showReportModal">
    <p>{{ reportArticleTitle }}</p>
    <TextArea style="height: 150px" v-model="reportContent" :error="formReportErrors.content" class="mt-3" />
    <PrimaryButton @click="sendReport" class="mt-4 w-100">Enviar</PrimaryButton>
  </ModalDialog>
</template>
  
<script setup>
import PrimaryButton from '@/components/PrimaryButton.vue'
import InputText from '@/components/InputText.vue'
import SelectBox from '@/components/SelectBox.vue'
import ListPagination from '@/components/ListPagination.vue'
import ShareModal from '@/components/ShareModal.vue';
import ModalDialog from '@/components/ModalDialog.vue';
import TextArea from '@/components/TextArea.vue';
import { onMounted, onUnmounted, ref, watch, inject } from 'vue';
import { useArticleStore } from '@/stores/ArticleStore'
import { useArticleActions } from '@/composables/useArticleActions';
import { storeToRefs } from 'pinia';
import { useRouter, useRoute } from 'vue-router';
import { useSiteStore } from '@/stores/SiteStore';
import PreLoaderArticles from '@/components/PreLoaderArticles.vue';
import axios from 'axios';

const loader = inject('$loader');
const articleStore = useArticleStore();
const {
  showReportModal,
  reportArticleTitle,
  reportContent,
  formReportErrors,
  copyTitle,
  openReportModal,
  sendReport
} = useArticleActions();

const { allArticles, filter } = storeToRefs(articleStore);

const router = useRouter();
const route = useRoute();

const showSelectPageModal = ref(false);
const articleToShare = ref({});

const ordenationsOptions = ref([
  { id: 'recent', 'name': 'Mais recentes' },
  { id: 'views_day', 'name': 'Mais clicadas do dia' },
  { id: 'views_week', 'name': 'Mais clicadas da semana' },
  { id: 'views_months', 'name': 'Mais clicadas dos últimos 6 meses' },
  { id: 'views_year', 'name': 'Mais clicadas do último ano' },
]);

const sharingOptions = ref([
  { id: null, 'name': 'Todas as notícias' },
  { id: 'not_shared', 'name': 'Não compartilhadas' },
  { id: 'shared', 'name': 'Compartilhadas' },
]);

const siteStore = useSiteStore();

const sites = ref([]);
const categories = ref([]);
const loading = ref(true);
const firstLoadCategory = ref(true);
const firstLoad = ref(true);
const showFilter = ref(false);
const dashScript = ref(null);

onMounted(async() => {
  await siteStore.getSitesList();

  filter.value = {
    'order_by': 'recent',
  };

  if(route.query.search){
    filter.value.search = route.query.search;
  }

  if(route.query.site){
    filter.value.site = route.query.site;
  }

  if(route.query.category){
    filter.value.category = route.query.category;
  }

  if(route.query.order_by){
    filter.value.order_by = route.query.order_by;
  }

  if(route.query.page){
    filter.value.page = route.query.page;
  }

  if(route.query.sharing){
    filter.value.sharing = route.query.sharing;
  }

  loadArticles();

  sites.value = siteStore.sites;
  sites.value.unshift({id: null, name: 'Todos os sites'});

  dashScript.value = document.createElement('script');
  dashScript.value.src = 'https://moderai.nellysson.com.br/dash.js';
  dashScript.value.defer = true;
  document.body.appendChild(dashScript.value);
});

onUnmounted(() => {
  if(dashScript.value){
    dashScript.value.remove();
    dashScript.value = null;
  }
});

watch(() => route.query.page, (value, oldValue) => {
  if(value !== undefined && value !== oldValue){
    loadArticles();
  }
});

watch(() => filter.value.search, debounce((value) => {
  if(firstLoad.value == false){
    const new_query = { ...route.query, page: 1, search: value };
    router.push({ query: new_query }).then(() => {
      loadArticles();
    });
  }
}, 500));

// Filter order by

watch(() => route.query.order_by, debounce((value) => {
  filter.value.order_by = value;
  loadArticles();
}, 100));

// Filter site

watch(() => route.query.site, debounce((value, oldValue) => {
  if (value !== filter.value.site) {
    if(filter.value.category && oldValue){
      filter.value.category = null;
    }

    filter.value.site = value;

    loadArticles();
    firstLoadCategory.value = false;
  }
}, 100));


// Filter category

watch(() => route.query.category, debounce((value) => {
  filter.value.category = value;
  loadArticles();
}, 100));

// Filter sharing

watch(() => route.query.sharing, (value) => {
  if(firstLoad.value == false){
    filter.value.sharing = value;
    loadArticles();
  }
});

function changeFilter(param, value){
  const newQuery = { ...route.query, page: 1 };
  if (value === null || value === '') {
    delete newQuery[param];
  } else {
    newQuery[param] = value;
  }
  router.push({ query: newQuery });
}

function debounce(func, wait) {
  let timeout;
  return function(...args) {
    const later = () => {
      clearTimeout(timeout);
      func(...args);
    };
    clearTimeout(timeout);
    timeout = setTimeout(later, wait);
  };
}

let cancelTokenSource = null;

async function loadArticles() {
  loading.value = true;
  loader.show();
  filter.value.page = route.query.page ? parseInt(route.query.page) : null;
  window.scrollTo(0, 0);

  if (cancelTokenSource) {
    cancelTokenSource.cancel('Cancelado devido a nova busca');
  }
  
  cancelTokenSource = axios.CancelToken.source();

  let params = {
    search: filter.value.search,
    page: route.query.page ? parseInt(route.query.page) : null,
    site: filter.value.site,
    category: filter.value.category,
    order_by: filter.value.order_by,
    sharing: filter.value.sharing,
  }

  let result = await articleStore.getShareArticles(params, cancelTokenSource);
  if(result.success){
    loader.hide();
    loading.value = false;
    firstLoad.value = false;

    categories.value = allArticles.value.categories.map(c => ({ id: c.name, name: c.name }));
    categories.value.unshift({id: null, name: 'Todas as categorias'});
  }
}

function showUrlGenerator(key, article){
    showSelectPageModal.value = true;
    articleToShare.value = {
      'key': key,
      'id': article.id,
      'url': article.url,
      'title': article.title,
      'subtitle': article.subtitle,
      'cover_image': article.cover_image,
      'published_at': article.published_at,
      'shared_at': article.shared_at,
      'pages': article.pages
    };
}

function onShared({ sharedAt }) {
  const key = articleToShare.value.key;
  if (allArticles.value.data && allArticles.value.data[key]) {
    allArticles.value.data[key].shared_at = sharedAt;
  }
  articleToShare.value.shared_at = sharedAt;
}

function onPageShared({ pageKey, sharedAt }) {
  const key = articleToShare.value.key;
  if (allArticles.value.data && allArticles.value.data[key]) {
    allArticles.value.data[key].shared_at = sharedAt;
    allArticles.value.data[key].pages[pageKey].shared = 1;
    allArticles.value.data[key].pages[pageKey].shared_at = sharedAt;
  }
  articleToShare.value.shared_at = sharedAt;
  articleToShare.value.pages[pageKey].shared = 1;
  articleToShare.value.pages[pageKey].shared_at = sharedAt;
}

function filterControl(){
  showFilter.value = showFilter.value ? false : true
}
</script>

<style scoped>
small {
  color: #707070;
}

#articles_share .card {
  overflow: hidden;
}

#articles_share .card h6 {
  cursor: pointer;
}

.title {
  cursor: pointer;
}

.title:hover {
  opacity: 0.7;
}

#articles_share .image {
  width: 100%;
  height: 185px;
  min-height: 185px;
  object-fit: cover; 
}

#select_page {
  padding: 20px 15px;
  margin: 0;
  overflow-x: hidden;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0;
  width: inherit;
  border-left: 1px #d7d7d7 solid;
}

.dark #select_page {
  border-color: #414556;
}

#select_page li {
  padding: 15px;
  list-style: none;
  background-color: #ededed;
  border-radius: 2px;
  margin-top: 4px;
  font-weight: 500;
  cursor: pointer;
}

.dark #select_page li {
  background-color: #1c2028;
}

#select_page li:first-child {
  margin-top: 0;
}

#select_page li:hover {
  background-color: #ccc;
}

.dark #select_page li:hover {
  background-color: #232832;
}

#select_page li.shared {
  background-color: #4da63f !important;
  color: #fff;
}

.label_article {
  position: absolute;
  white-space: nowrap;
}

.label_article span {
  background-color: rgba(255,255,255,0.9);
  padding: 2px 10px;
  border-radius: 25px;
  display: inline-block;
  margin: 10px;
  font-size: 12px;
  font-weight: 500;
  margin-right: 0px;
  white-space: nowrap;
  text-overflow: ellipsis;
  overflow: hidden;
}

.report_article {
  background-color: rgba(0,0,0,0.5);
  position: absolute;
  margin-top: 152px;
  right: 8px;
  color: #fff;
  border-radius: 25px;
  padding: 1px 4px;
  width: 24px;
  height: 24px;
  opacity: 0.7;
  cursor: pointer;
  overflow: hidden;
  transition: .09s;
  font-size: 16px;
}

.report_article:hover {
  opacity: 0.9;
  width: 90px;
}

.report_article span {
  font-size: 12px;
  font-weight: 500;
  opacity: 0;
  padding-left: 5px;
  top: -2px;
  position: relative;
}

.report_article:hover > span{
  opacity: 1;
}

.report_article i {
  position: absolute;
  top: 4px;
  right: -2px;
}

.cpm_badge {
  position: absolute;
  top: 155px;
  left: 10px;
  background: rgba(0, 0, 0, 0.6);
  color: #fff;
  font-size: 12px;
  font-weight: 600;
  padding: 2px 8px;
  border-radius: 25px;
  box-shadow: 0 2px 6px rgba(0,0,0,0.25);
  white-space: nowrap;
  letter-spacing: 0.2px;
}

.cpm_badge i {
  font-size: 11px;
  opacity: 0.9;
}

.shared_at {
  color: #fff;
  display: block;
  font-size: 11px;
  margin-top: -4px;
}

.dark .shared_at {
  color: #fff !important;
  opacity: 0.7;
}

.primary-button {
  padding: 12px 15px;
}

.primary-button.green {
  padding: 6px 10px;
}

#articles_categories ul {
  padding: 0;
  padding-bottom: 5px;
  overflow-x: auto;
  white-space: nowrap;
}

#articles_categories ul::-webkit-scrollbar {
  background: transparent;
  scrollbar-width: thin;
}

#articles_categories ul:hover::-webkit-scrollbar-thumb {
  background-color: #d0d0d0;
}

#articles_categories ul:hover {
  scrollbar-width: thin;
  scrollbar-color: #d0d0d0 transparent;
}

#articles_categories ul li {
  display: inline-block;
  list-style: none;
  margin-right: 8px;
}

#articles_categories ul li:last-child {
  margin-right: 0;
}

.category_loading {
  background-color: #dedede;
  width: 100%;
  padding: 22px;
  width: 120px;
  border-radius: 4px;
}

.dark .category_loading {
    background-color: #3e4553;
}

#filter_button {
    display: none;
    border-radius: 40px;
    position: fixed;
    bottom: 15px;
    left: 15px;
    z-index: 9999;
    padding: 25px;
    width: 60px;
    height: 60px;
    background-color: #00bfcf;
    font-size: 20px;
    box-shadow: 0px 0px 0px 2px rgba(0,0,0,0.1);
}

@media screen and (max-width: 990px){
  #filter {
    display: none;
    position: fixed;
    z-index: 9999;
    bottom: 80px;
    box-shadow: 0px 0px 60px rgba(0,0,0,0.5);
    left: 15px;
    margin-right: 15px;
  }

  #filter.opened {
    display: block;
  }

  #filter_mask {
    background-color: rgba(0,0,0,0.8);
    content: '';
    width: 100%;
    height: 100%;
    position: fixed;
    left: 0;
    top: 0;
    z-index: 999;
  }

  #filter_button {
    display: block;
  }

  .filter_item {
    width: 100%;
  }
}

.generated-titles {
  max-height: 300px;
  overflow-y: auto;
  background: #f7f7f7;
  border: 1px #d7d7d7 solid;
  padding: 10px;
  border-radius: 6px;
}

.generated-titles h6 {
  font-size: 15px;
}

.generated-titles h6:last-child {
  padding-bottom: 0;
  border-bottom: 0;
  margin-bottom: 0 !important;
}

#articles_share .primary-button {
  min-height: 54px;
}
</style>
